import { render } from "./corporateManage.vue?vue&type=template&id=6ce976c2&scoped=true"
import script from "./corporateManage.vue?vue&type=script&lang=js"
export * from "./corporateManage.vue?vue&type=script&lang=js"

import "./corporateManage.vue?vue&type=style&index=0&id=6ce976c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce976c2"]])

export default __exports__